<ng-container cdkDrag cdkDragRootElement=".cdk-overlay-pane">
	<div cdkDragHandle class="mep-dialog-header-icon">
		<mat-icon> palette</mat-icon>
	</div>
	<div class="mep-text-big-bold mep-dialog-title">{{ _lang("appearance") }}</div>
	<div class="mep-dialog-content" mat-dialog-content>
		<h2>{{ _lang("color-scheme-settings") }}</h2>
		<div id="us-custom-colors">
			<ng-container>
				<div id="us-custom-colors_defaults">
					@for (buttonColorScheme of defaultColorSchemes; track buttonColorScheme) {
						<ng-container [ngTemplateOutlet]="colorSpot" [ngTemplateOutletContext]="{buttonColorScheme}">
						</ng-container>
					}
				</div>
				<div id="us-custom-colors_presets">
					@for (buttonColorScheme of preconfiguredColorSchemes; track buttonColorScheme) {
						<ng-container [ngTemplateOutlet]="colorSpot" [ngTemplateOutletContext]="{buttonColorScheme}">
						</ng-container>
					}
					@for (buttonColorScheme of appearanceService.config.savedCustomColorSchemes(); track buttonColorScheme) {
						<ng-container
							[ngTemplateOutlet]="colorSpot"
							[ngTemplateOutletContext]="{buttonColorScheme, addedClasses: 'us-user-definable-color-spot'}"
						>
						</ng-container>
					}
					@if (appearanceService.hasCustomInitialColorScheme()) {
						<ng-container
							[ngTemplateOutlet]="colorSpot"
							[ngTemplateOutletContext]="{
								buttonColorScheme: appearanceService.initialColorScheme(),
								addedClasses: 'us-user-definable-color-spot',
							}"
						>
						</ng-container>
					}
				</div>
				<div id="us-custom-colors_user-defined">
					<button
						class="us-color-spot us-user-definable-color-spot"
						style="{{ '--mep-color-primary:' + appearanceService.computedUserDefinedColorScheme()?.primary }};
                 {{
							'--darkreader-border--mep-color-primary:' +
								appearanceService.computedUserDefinedColorScheme()?.primaryDark
						}};
                 {{ '--mep-color-light:' + appearanceService.computedUserDefinedColorScheme()?.light }};"
						[ngClass]="{
							'us-color-spot-active': appearanceService.colorSchemeEquals(
								appearanceService.computedUserDefinedColorScheme(),
								appearanceService.colorScheme()
							),
							'us-color-spot-disabled': appearanceService.computedUserDefinedColorScheme()?.primary == null,
						}"
						(click)="appearanceService.colorScheme.set(appearanceService.computedUserDefinedColorScheme())"
						[matTooltip]="_lang('user-defined-color-spot')"
						[disabled]="appearanceService.computedUserDefinedColorScheme()?.primary == null"
					></button>
					<mat-form-field>
						<input
							matInput
							placeholder="{{ _lang('user-defined-color') }}"
							[ngModel]="appearanceService.config.userDefinedColor()"
							(ngModelChange)="appearanceService.config.userDefinedColor.set($event)"
							[disabled]="appearanceService.config.exactUserDefinition() || appearanceService.config.osAccentColor()"
						/>
					</mat-form-field>
					<button
						class="mep-btn-small"
						[appActive]="appearanceService.config.exactUserDefinition()"
						(click)="appearanceService.updateUserDefinedColorScheme()"
						[matTooltip]="_lang('exactUserDefinition')"
					>
						<mat-icon class="mep-btn-small-icon"> edit</mat-icon>
					</button>
					@if (appearanceService.likelyBrowser() === Browser.FIREFOX) {
						<button
							class="mep-btn-small"
							[appActive]="appearanceService.config.osAccentColor()"
							(click)="appearanceService.config.osAccentColor.set(!appearanceService.config.osAccentColor())"
							[matTooltip]="_lang('osAccentColorTooltip')"
						>
							<mat-icon class="mep-btn-small-icon"> computer</mat-icon>
						</button>
					}
					<button
						class="mep-btn-small"
						(click)="appearanceService.saveColorScheme()"
						[matTooltip]="_lang('saveColorScheme')"
					>
						<mat-icon class="mep-btn-small-icon"> save</mat-icon>
					</button>
					<button class="mep-btn-small" (click)="appearanceService.deleteColorScheme()">
						<mat-icon class="mep-btn-small-icon"> delete</mat-icon>
					</button>
					@if (appearanceService.config.exactUserDefinition()) {
						<div id="us-custom-colors_user-defined-exact">
							<mat-form-field>
								<mat-label>{{ _lang("user-defined-exact-color.primary") }}</mat-label>
								<input
									matInput
									[ngModel]="appearanceService.userDefinedColorScheme.primary()"
									(ngModelChange)="appearanceService.userDefinedColorScheme.primary.set($event)"
								/>
							</mat-form-field>
							<mat-form-field>
								<mat-label>{{ _lang("user-defined-exact-color.primary-dark") }}</mat-label>
								<input
									matInput
									[ngModel]="appearanceService.userDefinedColorScheme.primaryDark()"
									(ngModelChange)="appearanceService.userDefinedColorScheme.primaryDark.set($event)"
								/>
							</mat-form-field>
							<mat-form-field>
								<mat-label>{{ _lang("user-defined-exact-color.light") }}</mat-label>
								<input
									matInput
									[ngModel]="appearanceService.userDefinedColorScheme.light()"
									(ngModelChange)="appearanceService.userDefinedColorScheme.light.set($event)"
								/>
							</mat-form-field>
							<mat-form-field>
								<mat-label>{{ _lang("user-defined-exact-color.border") }}</mat-label>
								<input
									matInput
									[ngModel]="appearanceService.userDefinedColorScheme.border()"
									(ngModelChange)="appearanceService.userDefinedColorScheme.border.set($event)"
								/>
							</mat-form-field>
						</div>
					}
				</div>
				<div id="us-custom-colors_dialogs"></div>
			</ng-container>
		</div>
		<h2>{{ _lang("functional-settings.header") }}</h2>
		<div id="us-personal-settings">
			<div class="us-slide-toggle-list">
				<mat-slide-toggle
					[disabled]="!isLineManager"
					[ngModel]="appearanceService.config.emailNotificationPVOutsideArea() || false"
					(ngModelChange)="updatePlanningNotification($event)"
				>
					{{ _lang("functional-settings.email-notification-pv-outside-area") }}
				</mat-slide-toggle>
				<mat-slide-toggle
					[ngModel]="appearanceService.config.stayInSameWindow() || false"
					(ngModelChange)="appearanceService.config.stayInSameWindow.set($event)"
				>
					{{ _lang("functional-settings.stay-in-same-window") }}
				</mat-slide-toggle>
			</div>
		</div>
		<mat-divider></mat-divider>
		<h2>{{ _lang("technical-settings.header") }}</h2>
		<div id="us-custom-dark-mode">
			<mat-form-field>
				<mat-label>{{ _lang("technical-settings.language") }}</mat-label>
				<mat-select [(ngModel)]="selectedLanguage" name="lang" (selectionChange)="onLanguageChange()">
					<mat-option [value]="LanguageEnum.DEFAULT"> Browser-{{ _lang("technical-settings.language") }} </mat-option>
					<mat-option [value]="LanguageEnum.DE">Deutsch</mat-option>
					<mat-option [value]="LanguageEnum.EN">English</mat-option>
				</mat-select>
			</mat-form-field>

			@if (window.matchMedia("(display-mode: standalone)").matches) {
				<mat-slide-toggle
					[ngModel]="appearanceService.config.colorTitleBarInPWA()"
					(ngModelChange)="appearanceService.config.colorTitleBarInPWA.set($event)"
				>
					{{ _lang("technical-settings.colored-title-bar-pwa") }}
				</mat-slide-toggle>
			}
			<mat-slide-toggle
				[ngModel]="appearanceService.config.disableZoom()"
				(ngModelChange)="appearanceService.config.disableZoom.set($event)"
			>
				{{ _lang("technical-settings.disable-zoom") }}
			</mat-slide-toggle>
			<mat-slide-toggle
				[ngModel]="appearanceService.config.dialogColor()"
				(ngModelChange)="appearanceService.config.dialogColor.set($event)"
			>
				{{ _lang("technical-settings.dialog-color-as-generated-from-theme") }}
			</mat-slide-toggle>
			<mat-divider></mat-divider>
			<mat-slide-toggle
				[ngModel]="appearanceService.config.darkModeColored()"
				(ngModelChange)="appearanceService.config.darkModeColored.set($event)"
			>
				{{ _lang("technical-settings.colorful-background-dark-mode") }}
			</mat-slide-toggle>
			<mat-slide-toggle
				[ngModel]="appearanceService.config.lightModeColored()"
				(ngModelChange)="appearanceService.config.lightModeColored.set($event)"
			>
				{{ _lang("technical-settings.colorful-background-light-mode") }}
			</mat-slide-toggle>
			<mat-divider></mat-divider>
			<mat-slide-toggle
				[ngModel]="appearanceService.config.darkModePitchBlack()"
				(ngModelChange)="appearanceService.config.darkModePitchBlack.set($event)"
				[matTooltip]="_lang('technical-settings.pitch-black-dark-mode-tooltip')"
			>
				{{ _lang("technical-settings.pitch-black-dark-mode") }}
			</mat-slide-toggle>

			<mat-slide-toggle
				[ngModel]="appearanceService.config.darkModePartialPitchBlack()"
				(ngModelChange)="appearanceService.config.darkModePartialPitchBlack.set($event)"
				[matTooltip]="_lang('technical-settings.partial-pitch-black-dark-mode-tooltip')"
			>
				{{ _lang("technical-settings.partial-pitch-black-dark-mode") }}
			</mat-slide-toggle>
			<mat-divider></mat-divider>
			<mat-slide-toggle
				[ngModel]="appearanceService.config.enableExperimentalFeatures()"
				(ngModelChange)="appearanceService.config.enableExperimentalFeatures.set($event)"
			>
				{{ _lang("experimentalSettings.enable") }}
			</mat-slide-toggle>
		</div>
		@if (
			appearanceService.config.enableExperimentalFeatures() &&
			Object.keys(appearanceService.experimentalFeatures).length > 0
		) {
			<h2>{{ _lang("experimentalSettings.header") }}</h2>
			<div class="us-slide-toggle-list">
				<mat-slide-toggle
					class=""
					[ngModel]="appearanceService.config.darkModeMutedPrimary()"
					(ngModelChange)="appearanceService.config.darkModeMutedPrimary.set($event)"
				>
					{{ _lang("experimentalSettings.muted-primary-color-in-dark-mode") }}
				</mat-slide-toggle>
				<mat-divider />
				@for (key of Object.keys(appearanceService.experimentalFeatures); track key) {
					<mat-slide-toggle
						[ngModel]="appearanceService.experimentalFeatures[key].signal()"
						(ngModelChange)="appearanceService.experimentalFeatures[key].signal.set($event)"
					>
						{{ _lang("experimentalSettings." + appearanceService.experimentalFeatures[key].title) }}
					</mat-slide-toggle>
				}
			</div>
		}
		<h2>{{ _lang("walkthrough.header") }}</h2>
		<p>{{ _lang("walkthrough.description") }}</p>
		<div class="us-slide-toggle-list">
			@for (walkthrough of Object.values(AppearanceHelperWalkthrough.walkthroughs); track walkthrough) {
				<div class="us-slide-toggle-list-walkthrough-item">
					<span>
						{{ _lang("walkthrough." + walkthrough.title) }}
					</span>
					@if (walkthrough.value()) {
						<button class="mep-btn-small" (click)="resetWalkthrough(walkthrough)">
							<mat-icon class="material-symbols-rounded">reset_wrench</mat-icon>
						</button>
					}
				</div>
			}
		</div>
	</div>
	<div class="mep-dialog-actions">
		<button class="mep-btn-dialog-secondary" appEscapeHotkey (click)="dialogRef.close()">
			{{ "mep.components.general.close" | translate }}
		</button>
	</div>

	<ng-template #colorSpot let-buttonColorScheme="buttonColorScheme" let-addedClasses="addedClasses">
		<button
			class="us-color-spot {{ addedClasses }}}"
			style="{{ '--mep-color-primary:' + buttonColorScheme.primary }};
                 {{ '--darkreader-border--mep-color-primary:' + buttonColorScheme.primaryDark }};
                 {{ '--mep-color-light:' + buttonColorScheme.light }};"
			[ngClass]="{
				'us-color-spot-active': appearanceService.colorSchemeEquals(buttonColorScheme, appearanceService.colorScheme()),
			}"
			(click)="appearanceService.colorScheme.set(buttonColorScheme)"
		></button>
	</ng-template>
</ng-container>
